<script setup>
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/vue/20/solid";
import { format, differenceInSeconds } from "date-fns";
import { computed, ref } from "vue";

const props = defineProps(["log", "previousLog"]);

const open = ref(false);

const toggle = () => {
    if (props.log.extras) {
        open.value = !open.value;
    }
};

const classes = computed(() => {
    switch (props.log.type) {
        case "success":
            return "border-green-500";
        case "warning":
            return "border-yellow-500";
        case "error":
            return "border-red-500";
        default:
            return "border-gray-500";
    }
});
</script>

<template>
    <div :class="['border-l-2 bg-gray-700/30 text-xs', classes]">
        <div @click="toggle" :class="['py-1.5 px-3 flex space-x-3', log.extras ? 'cursor-pointer hover:bg-gray-700' : '']">
            <div class="flex-1 text-white flex items-center gap-x-1.5 break-all lg:break-keep lg:break-words">
                <span class="flex-1 text-left">{{ log.message }}</span>
                <div v-if="log.extras" class="self-start flex-none">
                    <ChevronUpIcon v-if="open" class="w-4 h-4 text-gray-400" />
                    <ChevronDownIcon v-else class="w-4 h-4 text-gray-400" />
                </div>
            </div>
            <div class="flex-none text-gray-400">
                <span v-if="previousLog" class="mr-1.5">({{ differenceInSeconds(new Date(log.created_at), new Date(previousLog.created_at)) }}s)</span>
                <span>{{ format(new Date(log.created_at), "yyyy-MM-dd HH:mm:ss") }}</span>
            </div>
        </div>
        <div v-if="open" class="py-1.5 px-3 text-white">{{ log.extras }}</div>
    </div>
</template>
